/*
 * dashboard actions
 */

export const NS_GET_FIGURE_DATA = 'NS_GET_FIGURE_DATA';
export const NS_GET_FIGURE_DATA_SUCCESS = 'NS_GET_FIGURE_DATA_SUCCESS';
export const NS_GET_FIGURE_DATA_FAIL = 'NS_GET_FIGURE_DATA_FAIL';

export const NS_GET_ALERTS_HITS_CHART = 'NS_GET_ALERTS_HITS_CHART';
export const NS_GET_ALERTS_HITS_CHART_SUCCESS =
  'NS_GET_ALERTS_HITS_CHART_SUCCESS';
export const NS_GET_ALERTS_HITS_CHART_FAIL = 'NS_GET_ALERTS_HITS_CHART_FAIL';

export const NS_GET_HIT_YIELD_CHART = 'NS_GET_HIT_YIELD_CHART';
export const NS_GET_HIT_YIELD_CHART_SUCCESS = 'NS_GET_HIT_YIELD_CHART_SUCCESS';
export const NS_GET_HIT_YIELD_CHART_FAIL = 'NS_GET_HIT_YIELD_CHART_FAIL';

export const NS_GET_HITS_DISTRIBUTION_CHART = 'NS_GET_HITS_DISTRIBUTION_CHART';
export const NS_GET_HITS_DISTRIBUTION_CHART_SUCCESS =
  'NS_GET_HITS_DISTRIBUTION_CHART_SUCCESS';
export const NS_GET_HITS_DISTRIBUTION_CHART_FAIL =
  'NS_GET_HITS_DISTRIBUTION_CHART_FAIL';

export const NS_GET_SEGMENTS = 'NS_GET_SEGMENTS';
export const NS_GET_SEGMENTS_SUCCESS = 'NS_GET_SEGMENTS_SUCCESS';
export const NS_GET_SEGMENTS_FAIL = 'NS_GET_SEGMENTS_FAIL';

export const NS_GET_CUSTOMER_VIEW_DATA = 'NS_GET_CUSTOMER_VIEW_DATA';
export const NS_GET_CUSTOMER_VIEW_DATA_SUCCESS =
  'NS_GET_CUSTOMER_VIEW_DATA_SUCCESS';
export const NS_GET_CUSTOMER_VIEW_DATA_FAIL = 'NS_GET_CUSTOMER_VIEW_DATA_FAIL';

export const NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA =
  'NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA';
export const NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA_SUCCESS =
  'NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA_SUCCESS';
export const NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA_FAIL =
  'NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA_FAIL';

export function getFigureData(payload) {
  return {
    type: NS_GET_FIGURE_DATA,
    payload
  };
}

export function getFigureDataSuccess(payload) {
  return {
    type: NS_GET_FIGURE_DATA_SUCCESS,
    payload
  };
}

export function getFigureDataFail(payload) {
  return {
    type: NS_GET_FIGURE_DATA_FAIL,
    payload
  };
}

export function getAlertsAndHitsChart(payload) {
  return {
    type: NS_GET_ALERTS_HITS_CHART,
    payload
  };
}

export function getAlertsAndHitsChartSuccess(payload) {
  return {
    type: NS_GET_ALERTS_HITS_CHART_SUCCESS,
    payload
  };
}

export function getAlertsAndHitsChartFail(payload) {
  return {
    type: NS_GET_ALERTS_HITS_CHART_FAIL,
    payload
  };
}

export function getHitYieldChart(payload) {
  return {
    type: NS_GET_HIT_YIELD_CHART,
    payload
  };
}

export function getHitYieldChartSuccess(payload) {
  return {
    type: NS_GET_HIT_YIELD_CHART_SUCCESS,
    payload
  };
}

export function getHitYieldChartFail(payload) {
  return {
    type: NS_GET_HIT_YIELD_CHART_FAIL,
    payload
  };
}

export function getHitsDistributionChart(payload) {
  return {
    type: NS_GET_HITS_DISTRIBUTION_CHART,
    payload
  };
}

export function getHitsDistributionChartSuccess(payload) {
  return {
    type: NS_GET_HITS_DISTRIBUTION_CHART_SUCCESS,
    payload
  };
}

export function getHitsDistributionChartFail(payload) {
  return {
    type: NS_GET_HITS_DISTRIBUTION_CHART_FAIL,
    payload
  };
}

export function getSegments(payload) {
  return {
    type: NS_GET_SEGMENTS,
    payload
  };
}

export function getSegmentsSuccess(payload) {
  return {
    type: NS_GET_SEGMENTS_SUCCESS,
    payload
  };
}

export function getSegmentsFail(payload) {
  return {
    type: NS_GET_SEGMENTS_FAIL,
    payload
  };
}

export function getCustomerViewData(payload) {
  return {
    type: NS_GET_CUSTOMER_VIEW_DATA,
    payload
  };
}

export function getCustomerViewDataSuccess(payload) {
  return {
    type: NS_GET_CUSTOMER_VIEW_DATA_SUCCESS,
    payload
  };
}

export function getCustomerViewDataFail(payload) {
  return {
    type: NS_GET_CUSTOMER_VIEW_DATA_FAIL,
    payload
  };
}

export function getBusinessSegmentsParametersData(payload) {
  return {
    type: NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA,
    payload
  };
}

export function getBusinessSegmentsParametersDataSuccess(payload) {
  return {
    type: NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA_SUCCESS,
    payload
  };
}

export function getBusinessSegmentsParametersDataFail(payload) {
  return {
    type: NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA_FAIL,
    payload
  };
}
